// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-12-11T11:34:30+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  190785
//    Project:        617
//    Environment:    7626 - master
//    MD5:            8fec4ad4fe5c5b767d4627a91fe42ccd
//    Signature:      eyJpdiI6InBYMkF6ZTBsWitnUU5wMnlUbTg1R0E9PSIsInZhbHVlIjoiWnZTdGkxRGZSMEJyYk9tMiswWHlld21kMmxIKzNZam9zMVNNRFpqSEFUNUxFaDh1cis3c2R4V2VKU3BKV0VnYXlBSDl2OHdvVnQ2U0VcL0FPSER3SnpUQmszWkdGOUkzTk5ROUdsa1VzcFg3cmk3MHBCZDN0d09UUG1OMVlubXJxUFNURllHTk5zS2c5SUpQV0VJK1cxdGFnVVFpSjVRcU5FN1YrMUNlSkRMWGxVbTB5N3lhNTZnNnd1dGcyeWVsU1lBcjQzamlGWHhxUE1cL2FVZG5TNlwvd3RpZkhpanh4YXF4XC9KTDhXVVZcL3pLMllkSkdRSkN6aUR0RzNkSnNUMkxIQnNSOUJUTWtGaFdIVGtXeldjTDVEXC9UNG9iSjYyVW5reUFJSjJ1eE1YRWJ4Q3pMZlVnOTNQQmN0a25GOHkzOERFUDBNdHAxOXJSSXJyYWdJXC84dTJEM3JtcEVFZFwvUlBEeDI1bFRXYUVaSjhNZW1rMElUTnluTGhBTmhQYTZ6ZTU1TUxXbExaWWUrRTI4N0FiY1RoREMyZmJIOWtyeUVheWgxbXNcL0JoemllYz0iLCJtYWMiOiJhYTM1ZDY3OGYxY2FhMGNhN2FiYjI1Y2FmZGQ5ODYzNzVmYzY5ZWM1MjMxMjQ2MmQzMTE2NzU3YjU5MDk2ZmY5In0=
class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
